export const products = [

    // ===== قسم النواعم =====
    {
      id: 1,
      img: require('../images/naoem/kahk sada.png'),
      name: 'كحك سادة بلدي',
      price: 315,
      category: 'naoem'   
    },
    {
      id: 2,
      img: require('../images/naoem/Kahk Mlbn.jpeg'),
      name: 'كحك ملبن بلدي',
      price: 295,
      category: 'naoem'
    },
    {
      id: 3,
      img: require('../images/naoem/Kahk Mlbn.jpeg'),
      name: 'كحك ملبن خليط',
      price: 255,
      category: 'naoem'
    },
    {
      id: 4,
      img: require('../images/naoumCat.png'),
      name: 'كحك مكسرات بلدي',
      price: 310,
      category: 'naoem'
    },
    {
      id: 5,
      img: require('../images/naoumCat.png'),
      name: 'كحك مكسرات خليط',
      price: 270,
      category: 'naoem'
    },
    {
      id: 6,
      img: require('../images/naoem/kahk agwa.png'),
      name: 'كحك عجوة خليط',
      price: 255,
      category: 'naoem'
    },
    {
      id: 7,
      img: require('../images/naoem/biscuit.png'),
      name: ' بسكويت سادة بلدي',
      price: 295,
      category: 'naoem'
    },
    {
      id: 8,
      img: require('../images/naoem/biscuit.png'),
      name: ' بسكويت سادة خليط',
      price: 250,
      category: 'naoem'
    },
    {
      id: 9,
      img: require('../images/naoem/biscuit choco.png'),
      name: ' بسكويت شيكولاتة خليط',
      price: 275,
      category: 'naoem'
    },
    {
      id: 10,
      img: require('../images/naoem/biscuit.png'),
      name: ' بسكويت برتقال',
      price: 250,
      category: 'naoem'
    },
    {
      id: 11,
      img: require('../images/naoem/biscuit.png'),
      name: ' بسكويت جوزهند',
      price: 250,
      category: 'naoem'
    },
    {
      id: 12,
      img: require('../images/naoem/biscuit.png'),
      name: ' بسكويت شاي',
      price: 250,
      category: 'naoem'
    },
    {
      id: 13,
      img: require('../images/naoem/ghoriba.png'),
      name: ' غريبة بلدي',
      price: 315,
      category: 'naoem'
    },
    {
      id: 14,
      img: require('../images/naoem/بيتي فور.jpeg'),
      name: ' بيتي فور شوكولاتة بلدي',
      price: 310,
      category: 'naoem'
    },
    {
      id: 15,
      img: require('../images/naoem/بيتي فور.jpeg'),
      name: ' بيتي فور شوكولاتة خليط',
      price: 260,
      category: 'naoem'
    },
    {
      id: 16,
      img: require('../images/naoem/cookies.jpeg'),
      name: 'كوكيز شوكولاتة',
      price: 255,
      category: 'naoem'
    },
    {
      id: 17,
      img: require('../images/naoem/original.jpeg'),
      name: 'بيتي فور اورجينال صغير',
      price: 340,
      category: 'naoem'
    },
    {
      id: 18,
      img: require('../images/naoem/original.jpeg'),
      name: 'بيتي فور اورجينال كبير',
      price: 410,
      category: 'naoem'
    },
    {
      id: 19,
      img: require('../images/naoem/Sable.jpeg'),
      name: 'سابليه صغير',
      price: 360,
      category: 'naoem'
    },
    {
      id: 20,
      img: require('../images/naoem/Sable.jpeg'),
      name: 'سابليه كبير',
      price: 450,
      category: 'naoem'
    },
    {
      id: 21,
      img: require('../images/naoem/mix4.png'),
      name: ' مشكل بلدي',
      price: 330,
      category: 'naoem'
    },
    {
      id: 22,
      img: require('../images/naoem/mix4.png'),
      name: ' مشكل خليط',
      price: 300,
      category: 'naoem'
    },
    {
      id: 23,
      img: require('../images/westCat.png'),
      name: 'قطعة جاتوة اسبيشيال',
      price: 40,
      category: 'western'   
    },
    {
      id: 24,
      img: require('../images/westCat.png'),
      name: 'دستة جاتوة اسبيشيال',
      price: 480,
      category: 'western'   
    },
    {
      id: 25,
      img: require('../images/western/gatoR.jpeg'),
      name: 'قطعة جاتوة رويال',
      price: 50,
      category: 'western'   
    },
    {
      id: 26,
      img: require('../images/western/gatoR.jpeg'),
      name: 'دستة جاتوة رويال',
      price: 600,
      category: 'western'   
    },
    {
      id: 27,
      img: require('../images/western/gatoS.jpeg'),
      name: 'جاتوة سوارية',
      price: 330,
      category: 'western'   
    },
    {
      id: 28,
      img: require('../images/western/millfeh.png'),
      name: 'ميلفية',
      price: 50,
      category: 'western'   
    },
    {
      id: 29,
      img: require('../images/western/sansab.png'),
      name: 'جاتوة سان سيباستيان',
      price: 90,
      category: 'western'   
    },
    {
      id: 30,
      img: require('../images/western/eclaair.png'),
      name: 'أكلير',
      price: 50,
      category: 'western'   
    },
    {
      id: 31,
      img: require('../images/western/donut.jpg'),
      name: 'دوناتس',
      price: 60,
      category: 'western'   
    },
    {
      id: 32,
      img: require('../images/western/moltencake.png'),
      name: 'مولتن كيك كوفي',
      price: 100,
      category: 'western'   
    },
    {
      id: 33,
      img: require('../images/western/moltencake.png'),
      name: 'مولتن كيك لوتس',
      price: 100,
      category: 'western'   
    },
    {
      id: 34,
      img: require('../images/western/omAli.jpg'),
      name: 'طاجن أم علي',
      price: 65,
      category: 'western'   
    },
    {
      id: 35,
      img: require('../images/western/omAli.jpg'),
      name: 'طاجن أم علي لوتس',
      price: 70,
      category: 'western'   
    },
    {
      id: 36,
      img: require('../images/western/trilecha.png'),
      name: 'تريلتشا',
      price: 80,
      category: 'western'   
    },
    {
      id: 37,
      img: require('../images/western/tagenNut.png'),
      name: 'طاجن نوتيلا',
      price: 65,
      category: 'western'   
    },
    {
      id: 38,
      img: require('../images/western/orzBlbn.png'),
      name: 'أرز بلبن',
      price: 35,
      category: 'western'   
    },
    {
      id: 39,
      img: require('../images/western/orzBlbnlotus.png'),
      name: 'أرز بلبن لوتس',
      price: 40,
      category: 'western'   
    },
    {
      id: 40,
      img: require('../images/western/Despacito.jpeg'),
      name: 'ديسباسيتو',
      price: 100,
      category: 'western'   
    },
    {
      id: 41,
      img: require('../images/aboadellogo.jpeg'),
      name: 'كاس جاتوة',
      price: 55,
      category: 'western'   
    },
    {
      id: 42,
      img: require('../images/western/cheesecake.png'),
      name: 'تشيز كيك',
      price: 60,
      category: 'western'   
    },
    {
      id: 43,
      img: require('../images/aboadellogo.jpeg'),
      name: 'انجليش كيك',
      price: 90,
      category: 'western'   
    },
    {
      id: 44,
      img: require('../images/western/tart.png'),
      name: 'تارت',
      price: 50,
      category: 'western'   
    },
    {
      id: 45,
      img: require('../images/western/berfetrol.jpeg'),
      name: 'بيرفيترول',
      price: 60,
      category: 'western'   
    },
    {
      id: 46,
      img: require('../images/western/Cicroll.jpeg'),
      name: 'سيسرول',
      price: 60,
      category: 'western'   
    },
    {
      id: 47,
      img: require('../images/western/crumble.png'),
      name: 'كرمبل',
      price: 60,
      category: 'western'   
    },
    {
      id: 48,
      img: require('../images/western/hotcheesecake.png'),
      name: 'تشيز كيك سخن',
      price: 90,
      category: 'western'   
    },
    {
      id: 49,
      img: require('../images/western/brownie.png'),
      name: 'برونيز',
      price: 75,
      category: 'western'   
    },
    {
      id: 50,
      img: require('../images/western/sakhrCake.png'),
      name: 'جاتوة صخرة',
      price: 75,
      category: 'western'   
    },
    {
      id: 51,
      img: require('../images/western/jar.png'),
      name: 'جار',
      price: 80,
      category: 'western'   
    },
    {
      id: 52,
      img: require('../images/choco/sada.jpg'),
      name: 'الشوكولاته السادة',
      price: 400,
      category: 'choco'   
    },
    {
      id: 53,
      img: require('../images/choco/coffe.jpg'),
      name: 'الشوكولاته القهوه',
      price: 400,
      category: 'choco'   
    },
    {
      id: 54,
      img: require('../images/choco/gersy.jpg'),
      name: 'الشوكولاته الجيرسي',
      price: 400,
      category: 'choco'   
    },
    {
      id: 55,
      img: require('../images/choco/caramel.jpg'),
      name: 'الشوكولاته الكراميل',
      price: 400,
      category: 'choco'   
    },
    {
      id: 56,
      img: require('../images/choco/bondo2.jpg'),
      name: 'الشوكولاته البندق',
      price: 450,
      category: 'choco'   
    },
    {
      id: 57,
      img: require('../images/choco/loz.jpg'),
      name: 'الشوكولاته اللوز',
      price: 450,
      category: 'choco'   
    },
    {
      id: 58,
      img: require('../images/choco/aingamal.jpg'),
      name: 'الشوكولاته العين جمل',
      price: 450,
      category: 'choco'   
    },
    {
      id: 59,
      img: require('../images/choco/bondo2.jpg'),
      name: 'الشوكولاته الكاجو',
      price: 450,
      category: 'choco'   
    },
    {
      id: 60,
      img: require('../images/chocCat.png'),
      name: 'الشوكولاته المشكل',
      price: 425,
      category: 'choco'   
    },
    {
      id: 61,
      img: require('../images/chocCat.png'),
      name: 'شوكولاته مشكل مكسرات',
      price: 450,
      category: 'choco'   
    },
    {
      id: 62,
      img: require('../images/choco/milkbar.png'),
      name: 'شوكولاته بار سادة',
      price: 70,
      category: 'choco'   
    },
    {
      id: 63,
      img: require('../images/choco/milkbar.png'),
      name: 'شوكولاته بار بندق',
      price: 80,
      category: 'choco'   
    },
    {
      id: 64,
      img: require('../images/choco/darkbar.png'),
      name: 'شوكولاته بار دارك',
      price: 100,
      category: 'choco'   
    },
    {
      id: 65,
      img: require('../images/choco/bokeh.png'),
      name: 'بوكيه شوكولاته',
      price: 250,
      category: 'choco'   
    },
    {
      id: 66,
      img: require('../images/choco/nuetella.png'),
      name: 'برطمان نيوتيلا',
      price: 120,
      category: 'choco'   
    },
    {
      id: 67,
      img: require('../images/choco/penut.png'),
      name: 'برطمان فول سوداني',
      price: 120,
      category: 'choco'   
    },
    {
      id: 68,
      img: require('../images/bakery/cheesecroiss.jpg'),
      name: 'كرواسون سادة (1 قطعة)',
      price: 45,
      category: 'bakery'   
    },
    {
      id: 69,
      img: require('../images/bakery/cheesecroiss.jpg'),
      name: 'كرواسون سادة (2 قطع)',
      price: 90,
      category: 'bakery'   
    },
    {
      id: 70,
      img: require('../images/bakery/bakeCat.png'),
      name: 'كرواسون شيدر ورومي',
      price: 130,
      category: 'bakery'   
    },
    {
      id: 71,
      img: require('../images/bakery/bakeCat.png'),
      name: 'كرواسون شيدر',
      price: 65,
      category: 'bakery'   
    },
    {
      id: 72,
      img: require('../images/bakery/croassiontchoc.png'),
      name: 'كرواسون نوتيلا',
      price: 120,
      category: 'bakery'   
    },
    {
      id: 73,
      img: require('../images/bakery/croassiontchoc.png'),
      name: 'كرواسون أوريو',
      price: 120,
      category: 'bakery'   
    },
    {
      id: 74,
      img: require('../images/bakery/croassiontchoc.png'),
      name: 'كرواسون لوتس',
      price: 120,
      category: 'bakery'   
    },
    {
      id: 75,
      img: require('../images/bakery/minicroass.png'),
      name: 'طبق ميني كرواسون مشكل',
      price: 100,
      category: 'bakery'   
    },
    {
      id: 76,
      img: require('../images/bakery/batielarge.jpg'),
      name: 'باتيه جبنة كبير',
      price: 100,
      category: 'bakery'   
    },
    {
      id: 77,
      img: require('../images/bakery/batieza3ter.jpeg'),
      name: 'باتيه شيدر و زعتر',
      price: 100,
      category: 'bakery'   
    },
    {
      id: 78,
      img: require('../images/bakery/batie.png'),
      name: 'ميني باتيه جبنة (طبق)',
      price: 95,
      category: 'bakery'   
    },
    {
      id: 79,
      img: require('../images/bakery/batie.png'),
      name: 'ميني باتيه جبنة (كيلو)',
      price: 220,
      category: 'bakery'   
    },
    {
      id: 80,
      img: require('../images/bakery/cinnabon.png'),
      name: 'سينابون',
      price: 100,
      category: 'bakery'   
    },
    {
      id: 81,
      img: require('../images/bakery/danshstraw.png'),
      name: 'دنش بونسوليس',
      price: 100,
      category: 'bakery'   
    },
    {
      id: 82,
      img: require('../images/bakery/Cream Danish.jpeg'),
      name: 'دنش كريمة وسكر',
      price: 100,
      category: 'bakery'   
    },
    {
      id: 83,
      img: require('../images/bakery/danshnuet.jpeg'),
      name: 'دنش بريوش',
      price: 120,
      category: 'bakery'   
    },
    {
      id: 84,
      img: require('../images/bakery/supreme.png'),
      name: 'سوبريم نوتيلا',
      price: 70,
      category: 'bakery'   
    },
    {
      id: 85,
      img: require('../images/bakery/supreme.png'),
      name: 'سوبريم لوتس',
      price: 70,
      category: 'bakery'   
    },
    {
      id: 86,
      img: require('../images/bakery/minipizza.jpeg'),
      name: 'ميني بيتزا خضار (قطع)',
      price: 4,
      category: 'bakery'   
    },
    {
      id: 87,
      img: require('../images/bakery/minipizza.jpeg'),
      name: 'ميني بيتزا خضار (كيلو)',
      price: 230,
      category: 'bakery'   
    },
    {
      id: 88,
      img: require('../images/bakery/salizon.png'),
      name: 'ساليزون كيلو',
      price: 280,
      category: 'bakery'   
    },
    {
      id: 89,
      img: require('../images/bakery/feter.png'),
      name: 'فطير سادة',
      price: 120,
      category: 'bakery'   
    },
    {
      id: 90,
      img: require('../images/bakery/feter.png'),
      name: 'فطير سادة بلدي',
      price: 180,
      category: 'bakery'   
    },
    {
      id: 91,
      img: require('../images/bakery/boghasha.png'),
      name: 'فطيرة بغاشة',
      price: 120,
      category: 'bakery'   
    },
    {
      id: 92,
      img: require('../images/bakery/bo2smat.jpeg'),
      name: 'بقصمات (كيلو)',
      price: 160,
      category: 'bakery'   
    },
    {
      id: 93,
      img: require('../images/bakery/batosali.jpeg'),
      name: 'باتون ساليه (كيلو)',
      price: 160,
      category: 'bakery'
    },
    {
      id: 94,
      img: require('../images/naoem/cookies.jpeg'),
      name: 'كوكيز طبق',
      price: 60,
      category: 'bakery'   
    },
    {
      id: 95,
      img: require('../images/naoem/biscuit.png'),
      name: 'بسكوت شاي طبق',
      price: 60,
      category: 'bakery'   
    },
    {
      id: 96,
      img: require('../images/bakery/toast.jpg'),
      name: 'عيش توست',
      price: 75,
      category: 'bakery'   
    },
    {
      id: 97,
      img: require('../images/aboadellogo.jpeg'),
      name: 'عيش سن',
      price: 20,
      category: 'bakery'   
    },
    {
      id: 98,
      img: require('../images/bakery/feno.png'),
      name: 'فينو (5 قطع)',
      price: 40,
      category: 'bakery'   
    },
    {
      id: 99,
      img: require('../images/bakery/kaizer.png'),
      name: 'كيذر (4 قطع)',
      price: 40,
      category: 'bakery'   
    },
    {
      id: 100,
      img: require('../images/eastern/mshklnawashf.png'),
      name: 'مشكل طري',
      price: 300,
      category: 'eastern'   
    },
    {
      id: 101,
      img: require('../images/eastern/mshklnawashf.png'),
      name: 'مشكل طري + نواشف',
      price: 370,
      category: 'eastern'   
    },
    {
      id: 102,
      img: require('../images/eastern/mshklnuts.jpg'),
      name: 'مشكل نواشف',
      price: 380,
      category: 'eastern'   
    },
    {
      id: 103,
      img: require('../images/eastern/mshklnuts.jpg'),
      name: 'مشكل نواشف مكسرات',
      price: 500,
      category: 'eastern'   
    },
    {
      id: 104,
      img: require('../images/eastern/lenza.jpg'),
      name: 'لينزا',
      price: 245,
      category: 'eastern'   
    },
    {
      id: 105,
      img: require('../images/eastern/lenzablh.jpg'),
      name: 'لينزا بلح',
      price: 360,
      category: 'eastern'   
    },
    {
      id: 106,
      img: require('../images/aboadellogo.jpeg'),
      name: 'مكرونة',
      price: 200,
      category: 'eastern'   
    },
    {
      id: 107,
      img: require('../images/eastern/daloaa.png'),
      name: 'دلوعة',
      price: 275,
      category: 'eastern'   
    },
    {
      id: 108,
      img: require('../images/eastern/bl7elshamsada.png'),
      name: 'بلح الشام',
      price: 245,
      category: 'eastern'   
    },
    {
      id: 109,
      img: require('../images/eastern/blhelshamcream.jpg'),
      name: 'بلح شام كريمة',
      price: 270,
      category: 'eastern'   
    },
    {
      id: 110,
      img: require('../images/eastern/bl7shamnuet.png'),
      name: 'بلح الشام نيوتيلا',
      price: 280,
      category: 'eastern'   
    },
    {
      id: 111,
      img: require('../images/eastern/bl7shamnuet.png'),
      name: 'بلح الشام لوتس',
      price: 290,
      category: 'eastern'   
    },
    {
      id: 112,
      img: require('../images/aboadellogo.jpeg'),
      name: 'لديدة',
      price: 370,
      category: 'eastern'   
    },
    {
      id: 113,
      img: require('../images/aboadellogo.jpeg'),
      name: 'تروبيكانة',
      price: 360,
      category: 'eastern'   
    },
    {
      id: 114,
      img: require('../images/eastern/basbousasada.png'),
      name: 'بسبوسة سادة',
      price: 225,
      category: 'eastern'   
    },
    {
      id: 115,
      img: require('../images/eastern/basbousasada.png'),
      name: 'بسبوسة تركي',
      price: 255,
      category: 'eastern'   
    },
    {
      id: 116,
      img: require('../images/eastern/basbousanuts.png'),
      name: 'بسبوسة مكسرات',
      price: 260,
      category: 'eastern'   
    },
    {
      id: 117,
      img: require('../images/eastern/basbousanuts.png'),
      name: 'بسبوسة بندق',
      price: 270,
      category: 'eastern'   
    },
    {
      id: 118,
      img: require('../images/eastern/24ta.jpg'),
      name: 'بسبوسة قشطة',
      price: 245,
      category: 'eastern'   
    },
    {
      id: 119,
      img: require('../images/eastern/lotus.jpg'),
      name: 'بسبوسة تشيز لوتس',
      price: 290,
      category: 'eastern'   
    },
    {
      id: 120,
      img: require('../images/eastern/caramel.jpg'),
      name: 'بسبوسة تشيز كراميل',
      price: 290,
      category: 'eastern'   
    },
    {
      id: 121,
      img: require('../images/eastern/konafasada.jpg'),
      name: 'كنافة سادة',
      price: 290,
      category: 'eastern'   
    },
    {
      id: 122,
      img: require('../images/eastern/snickers.jpg'),
      name: 'كنافة اسينكرز',
      price: 340,
      category: 'eastern'   
    },
    {
      id: 123,
      img: require('../images/eastern/konafamanga.jpeg'),
      name: 'كنافة مانجو',
      price: 440,
      category: 'eastern'   
    },
    {
      id: 124,
      img: require('../images/eastern/konafacream.png'),
      name: 'كنافة كريمة',
      price: 270,
      category: 'eastern'   
    },
    {
      id: 125,
      img: require('../images/aboadellogo.jpeg'),
      name: 'كنافة خشاف',
      price: 375,
      category: 'eastern'   
    },
    {
      id: 126,
      img: require('../images/aboadellogo.jpeg'),
      name: 'كنافة عنتابلي لوز',
      price: 450,
      category: 'eastern'   
    },
    {
      id: 127,
      img: require('../images/aboadellogo.jpeg'),
      name: 'كنافة عنتابلي بندق',
      price: 420,
      category: 'eastern'   
    },
    {
      id: 128,
      img: require('../images/eastern/konafacream.png'),
      name: 'كنافة عثمانلي',
      price: 320,
      category: 'eastern'   
    },
    {
      id: 129,
      img: require('../images/eastern/konafashahd.jpg'),
      name: 'كنافة شهد',
      price: 300,
      category: 'eastern'   
    },
    {
      id: 130,
      img: require('../images/eastern/kornehnutella.jpg'),
      name: 'كنافة كورنيه نيوتيلا',
      price: 330,
      category: 'eastern'   
    },
    {
      id: 131,
      img: require('../images/eastern/konafakornehbst.jpeg'),
      name: 'كنافة كورنيه كريمة',
      price: 330,
      category: 'eastern'   
    },
    {
      id: 132,
      img: require('../images/eastern/asawernutella.jpg'),
      name: 'كنافة أساور نيوتيلا',
      price: 320,
      category: 'eastern'   
    },
    {
      id: 133,
      img: require('../images/eastern/konafaasawer.png'),
      name: 'كنافة أساور لوز',
      price: 470,
      category: 'eastern'   
    },
    {
      id: 134,
      img: require('../images/eastern/konafaasawer.png'),
      name: 'كنافة أساور بندق',
      price: 470,
      category: 'eastern'   
    },
    {
      id: 135,
      img: require('../images/eastern/asawerbondo2.jpg'),
      name: 'كنافة أساور كاجو',
      price: 460,
      category: 'eastern'   
    },
    {
      id: 136,
      img: require('../images/aboadellogo.jpeg'),
      name: 'كنافة سيجار سادة',
      price: 310,
      category: 'eastern'   
    },
    {
      id: 137,
      img: require('../images/aboadellogo.jpeg'),
      name: 'كنافة سيجار بندق',
      price: 500,
      category: 'eastern'   
    },
    {
      id: 138,
      img: require('../images/eastern/konafabormaandbasma.png'),
      name: 'كنافة بصمة بندق',
      price: 470,
      category: 'eastern'   
    },
    {
      id: 139,
      img: require('../images/eastern/konafabormaandbasma.png'),
      name: 'كنافة بصمة لوز',
      price: 470,
      category: 'eastern'   
    },
    {
      id: 140,
      img: require('../images/eastern/konafabormaandbasma.png'),
      name: 'كنافة بصمة كاجو',
      price: 540,
      category: 'eastern'   
    },
    {
      id: 141,
      img: require('../images/eastern/konafabormaandbasma.png'),
      name: 'كنافة بورمة فستق',
      price: 1010,
      category: 'eastern'   
    },
    {
      id: 142,
      img: require('../images/eastern/konafabormaandbasma.png'),
      name: 'كنافة بورمة كاجو',
      price: 590,
      category: 'eastern'   
    },
    {
      id: 143,
      img: require('../images/eastern/ba2laoa.png'),
      name: 'بقلاوة سادة',
      price: 320,
      category: 'eastern'   
    },
    {
      id: 144,
      img: require('../images/eastern/ba2lawalotus.jpg'),
      name: 'بقلاوة لوتس',
      price: 440,
      category: 'eastern'   
    },
    {
      id: 145,
      img: require('../images/eastern/b2lawanutella.jpg'),
      name: 'بقلاوة نيوتيلا',
      price: 440,
      category: 'eastern'   
    },
    {
      id: 146,
      img: require('../images/eastern/ba2lawaaingamal.jpg'),
      name: 'بقلاوة عين جمل',
      price: 440,
      category: 'eastern'   
    },
    {
      id: 147,
      img: require('../images/eastern/ba2lawabondo2.jpg'),
      name: 'بقلاوة بندق',
      price: 440,
      category: 'eastern'   
    },
    {
      id: 148,
      img: require('../images/eastern/ba2lawafost2.jpg'),
      name: 'بقلاوة فستق',
      price: 590,
      category: 'eastern'   
    },
    {
      id: 149,
      img: require('../images/eastern/ba2laoa.png'),
      name: 'بقلاوة كريمة',
      price: 300,
      category: 'eastern'   
    },
    {
      id: 150,
      img: require('../images/tart/halfregula.jpg'),
      name: 'تورتة متوسطة',
      price: 475,
      category: 'tart'   
    },
    {
      id: 151,
      img: require('../images/tart/halfbig.jpg'),
      name: 'تورتة كبيرة',
      price: 530,
      category: 'tart'   
    },
    {
      id: 152,
      img: require('../images/tart/blackforest.jpg'),
      name: 'تورته بلاك فورست',
      price: 530,
      category: 'tart'   
    },
    {
      id: 153,
      img: require('../images/tart/fruit2.jpg'),
      name: 'تورتة فاكهة',
      price: 530,
      category: 'tart'   
    },
    {
      id: 154,
      img: require('../images/tartCat.png'),
      name: 'نص فادج ونص فاكهه',
      price: 530,
      category: 'tart'   
    },
    {
      id: 155,
      img: require('../images/tart/vadj.jpg'),
      name: 'تورتة فادج',
      price: 450,
      category: 'tart'   
    },
    {
      id: 156,
      img: require('../images/tart/4season.jpg'),
      name: 'تورتة 4 سيزون ',
      price: 530,
      category: 'tart'   
    },
    {
      id: 157,
      img: require('../images/tart/8season.jpg'),
      name: 'تورتة 8 سيزون ',
      price: 530,
      category: 'tart'   
    },
    {
      id: 158,
      img: require('../images/tart/melfeh.jpg'),
      name: 'تورتة ميلفيه',
      price: 610,
      category: 'tart'   
    },
    {
      id: 159,
      img: require('../images/tart/choco.jpg'),
      name: 'تورتة شيكولاتة',
      price: 460,
      category: 'tart'   
    },
    {
      id: 160,
      img: require('../images/tart/miniamercchoc.jpg'),
      name: 'ميني اميرکن شوكلت',
      price: 470,
      category: 'tart'   
    },
    {
      id: 161,
      img: require('../images/tart/floatsfruit.jpg'),
      name: 'نص فلوتس و فاكهه',
      price: 590,
      category: 'tart'   
    },
    {
      id: 162,
      img: require('../images/tart/kitkatfruit.jpg'),
      name: 'تورتة كيت كات',
      price: 610,
      category: 'tart'   
    },
    {
      id: 163,
      img: require('../images/tart/mango.jpg'),
      name: 'تورتة مانجو',
      price: 530,
      category: 'tart'   
    },
    {
      id: 164,
      img: require('../images/tart/halfsnickersfruit.jpg'),
      name: 'تورتة سنيكرز وفاكهة',
      price: 540,
      category: 'tart'   
    },
    {
      id: 165,
      img: require('../images/tart/lotus.jpg'),
      name: 'تورتة لوتس',
      price: 530,
      category: 'tart'   
    },
    {
      id: 166,
      img: require('../images/tart/ro4eh.jpg'),
      name: 'تورتة روشيه',
      price: 530,
      category: 'tart'   
    },
    {
      id: 167,
      img: require('../images/tart/halfro4ehfruit.jpg'),
      name: 'تورتة نص روشية و فاكهة',
      price: 530,
      category: 'tart'   
    },
    {
      id: 168,
      img: require('../images/tart/americanrush.jpg'),
      name: 'تورتة أمريكن راش',
      price: 590,
      category: 'tart'   
    },
    {
      id: 169,
      img: require('../images/tart/30f30.jpg'),
      name: 'تورتة 30*30',
      price: 710,
      category: 'tart'   
    },
    {
      id: 170,
      img: require('../images/tart/30f30.jpg'),
      name: 'تورتة 30*30 بصوره',
      price: 780,
      category: 'tart'   
    },
    {
      id: 171,
      img: require('../images/tart/sizes.jpg'),
      name: 'تورته 40*30 ',
      price: 940,
      category: 'tart'   
    },
    {
      id: 172,
      img: require('../images/tart/sizes.jpg'),
      name: 'تورته 40*30 بصوره صغيره',
      price: 1010,
      category: 'tart'   
    },
    {
      id: 173,
      img: require('../images/tart/sizes.jpg'),
      name: 'تورته 40*30 بصوره كبيره',
      price: 1030,
      category: 'tart'   
    },
    {
      id: 174,
      img: require('../images/tart/sizes.jpg'),
      name: 'تورته 40*40',
      price: 1080,
      category: 'tart'   
    },
    {
      id: 175,
      img: require('../images/tart/sizes.jpg'),
      name: 'تورته 40*40 بصوره صغيره',
      price: 1140,
      category: 'tart'   
    },
    {
      id: 176,
      img: require('../images/tart/sizes.jpg'),
      name: 'تورته 40*40 بصوره كبيره',
      price: 1170,
      category: 'tart'   
    },
    {
      id: 177,
      img: require('../images/tart/sizes.jpg'),
      name: 'تورته 60*40',
      price: 1480,
      category: 'tart'   
    },
    {
      id: 178,
      img: require('../images/tart/sizes.jpg'),
      name: 'تورته 60*40 بصوره صغيره',
      price: 1600,
      category: 'tart'   
    },
    {
      id: 179,
      img: require('../images/tart/sizes.jpg'),
      name: 'تورته 60*40 بصوره كبيره',
      price: 1650,
      category: 'tart'   
    },
    {
      id: 180,
      img: require('../images/tart/sizes.jpg'),
      name: 'تورته 60*60',
      price: 2390,
      category: 'tart'   
    },
    {
      id: 181,
      img: require('../images/tart/sizes.jpg'),
      name: 'تورته 60*60 بصوره صغيره',
      price: 2450,
      category: 'tart'   
    },
    {
      id: 182,
      img: require('../images/tart/sizes.jpg'),
      name: 'تورته 60*60 بصوره كبيره',
      price: 2470,
      category: 'tart'   
    },
    {
      id: 183,
      img: require('../images/tart/sizes.jpg'),
      name: 'تورته 80*60 بصوره ',
      price: 3170,
      category: 'tart'   
    },
    {
      id: 184,
      img: require('../images/tart/dor.jpg'),
      name: 'تورته مقاس 18',
      price: 950,
      category: 'tart'   
    },
    {
      id: 185,
      img: require('../images/tart/dor.jpg'),
      name: 'تورته مقاس 24',
      price: 1150,
      category: 'tart'   
    },
    {
      id: 186,
      img: require('../images/tart/dor.jpg'),
      name: 'تورته مقاس 26',
      price: 1300,
      category: 'tart'   
    },
    {
      id: 187,
      img: require('../images/tart/dor.jpg'),
      name: 'تورته 2 دور ',
      price: 2150,
      category: 'tart'   
    },
    {
      id: 188,
      img: require('../images/tart/dor.jpg'),
      name: 'تورته 3 دور ',
      price: 2700,
      category: 'tart'   
    },
    {
      id: 189,
      img: require('../images/tart/dor.jpg'),
      name: 'تورته 4 دور ',
      price: 3950,
      category: 'tart'   
    },
    {
      id: 190,
      img: require('../images/tart/dor.jpg'),
      name: 'تورته 5 دور ',
      price: 4950,
      category: 'tart'   
    },
    {
      id: 191,
      img: require('../images/tart/dor.jpg'),
      name: 'تورته 6 دور ',
      price: 6150,
      category: 'tart'   
    },
    {
      id: 192,
      img: require('../images/tart/dor.jpg'),
      name: 'تورته 7 دور ',
      price: 7150,
      category: 'tart'   
    }
];
